<template>
	<div>
		<list-renderer :apiUrl="'/api/' + selectedSite.slug + '/labels/lister'" :filterIn="filterIn" :listInData="'labels'" :listType="'general'" :orderBy="orderBy" :orderByRules="orderByRules">
			<template #header="{title}">
				<h2>Labels</h2>
			</template>
			<template #content='{list}'>
				<div class="table-lister table-responsive">
					<table>
						<thead>
							<tr>
								<th>
									<div class="flex start flex-nowrap">
										<span class="th">Label</span>
									</div>
								</th>
								<th>
									<div class="flex start flex-nowrap">
										<span class="th">Has hub</span>
									</div>
								</th>
								<th>
									<div class="flex start flex-nowrap">
										<span class="th">Articles</span>
									</div>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(label,index) in list">
								<td>{{ label.name }}</td>
								<td class="hasFunction" title="click to change" @click="changeHasHub(label.id,!tag.has_hub)">
									<div class="switches">
										<input id="tr-notify-1" :name="'tr_notify_' + index" class="switch-true" type="radio" :checked="label.has_hub">
										<label class="label-checkbox">Yes</label>
										<input id="tr-notify-0" :name="'tr_notify_' + index" class="switch-false" type="radio" :checked="!label.has_hub">
										<label class="label-checkbox">No</label>
									</div>
								</td>
								<td class="hasFunction" title="click to view" @click="getArticlesForTag(label.id)">{{ label.occurrences }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</template>
		</list-renderer>
		<modal @close="closeModal" v-show="isModalVisible">
			<template slot="header">
				<h4 class="modal-title">Attached Articles</h4>
			</template>
			<template slot="body">
				<table>
					<thead>
						<tr>
							<th>
								<div class="flex start flex-nowrap">
									<span class="th">ID</span>
								</div>
							</th>
							<th>
								<div class="flex start flex-nowrap">
									<span class="th">Title</span>
								</div>
							</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="article in sortedArticles">
							<td>{{ article.id }}</td>
							<td>{{ article.title }}</td>
							<td>
								<a target="_blank" :href="selectedSite.actualUrl + '/' + article.url">view </a>/<a target="_blank" :href="'/' + selectedSite.slug + '/articles/' + article.id +'/edit/?tab=content'"> edit</a>
							</td>
						</tr>
					</tbody>
				</table>
			</template>
			<template slot="footer">
				<a @click="closeModal" class="btn btn-md btn-primary modal-close"><i class="fas fa-times"></i> Close</a>
			</template>
		</modal>
	</div>
</template>

<script>
import modal from '../Modal/DefaultModal.vue';
import {eventBus} from "../../app";

export default {
	name: 'LabelsPage',
	components: {
		modal
	},
	data() {
		return {
			selectedSite: this.$selectedSite,
			filterIn: ['name'],
			orderBy: ['name'],
			orderByRules: ['asc'],
			articles: {},
			isModalVisible: false,
		}
	},
	computed: {
		sortedArticles: function () {
			return _.orderBy(this.articles, ['title'], ['asc'])
		}
	},
	methods: {
		closeModal: function () {
			this.isModalVisible = false;
		},
		getArticlesForTag: function (id) {
			let vm = this;
			axios.get('/api/' + this.selectedSite.slug + '/labels/getarticles/' + id)
				.then(response => {
					if (response.data.hasOwnProperty('data')) {
						vm.articles = response.data.data;
						vm.isModalVisible = true;
					}
				})
				.catch(e => {
					vm.$toastr.error('Articles loading failed', 'Error');
				});
		},
		changeHasHub: function (id, value) {
			let vm = this;
			vm.$dialog.confirm('Are you sure you want to change the hub status to ' + value + '?', {
				loader: true
			})
				.then((dialog) => {
					axios.post('/api/' + this.selectedSite.slug + '/labels/update/' + id, {
						label: {
							has_hub: value,
						}
					})
						.then(response => {
							eventBus.$emit('listRenderer-fetch');
						})
						.catch(e => {
							vm.$toastr.error('Label updating failed', 'Error');
						});
					dialog.close();
				});
		}
	}
}
</script>

<style scoped>
td.hasFunction {
	cursor: pointer;
}
</style>
